<template>
  <ReactSiteFrame :src="src" />
</template>
<script>
import ReactSiteFrame from '../components/react/iframe'

export default {
  name: 'ProvidersReact',
  components: {
    ReactSiteFrame
  },
  data() {
    return {
      src: '/view/providers'
    }
  }
}
</script>
